import React from 'react';
import {t} from '@lingui/core/macro';

import {getFormattedDate} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';
import {PALETTE} from 'shared/config/model/palette';

interface IDateWithTodayYesterdayAccentProps {
    datetime: string|null,
    tzString?: string|null,
    isResolvedDate?: boolean,
}

const DateWithTodayYesterdayAccent: React.FC<IDateWithTodayYesterdayAccentProps> = ({
    datetime,
    tzString,
    isResolvedDate = false,
}) => {
    if (null === datetime) {
        return <>-</>;
    }

    let dateText = getFormattedDate(
        datetime,
        {format: !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm', tzString},
    );
    let color: string = PALETTE.neutralEn;

    if (!isResolvedDate) {
        const itemDate = new Date(datetime);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const timeText = getFormattedDate(datetime, {format: 'HH:mm', tzString});

        if (itemDate.toDateString() === today.toDateString()) {
            color = PALETTE.error; // Красный для сегодня
            dateText = `${t`Сегодня, в`} ${timeText}`;
        } else if (itemDate.toDateString() === yesterday.toDateString()) {
            color = PALETTE.accentSecondary; // Фиолетовый для вчера
            dateText = `${t`Вчера, в`} ${timeText}`;
        }
    }

    return (
        <span style={{color}}>{dateText}</span>
    );
};

export default DateWithTodayYesterdayAccent;